<script lang="ts">
	import { loop_guard } from 'svelte/internal';

	import Screen from '../components/Screen.svelte';
	import { currentLevel, gameStart, gameState, winner } from '../stores/winState';

	export let levelNum = 0;
</script>

<Screen>
	<div class="winner-screen">
		<p>congratulations !!</p>
		<div class="action-buttons">
			<button
				on:click={() => {
					$gameState = 'splash';
					$winner = false;
				}}>home</button
			>
			<button
				on:click={() => {
					$gameState = 'level';
					if (levelNum >= $currentLevel) {
						$currentLevel = $currentLevel + 1;
					}
					$gameStart = false;
					$winner = false;
				}}>contine</button
			>
		</div>
	</div>
</Screen>

<style>
	.action-buttons {
		width: 100%;
		height: auto;
		display: flex;
		justify-content: space-between;
		padding: 0 30px;
		box-sizing: border-box;
	}
	.winner-screen {
		border-radius: 10px;
		width: 250px;
		height: 150px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: #75c9b7;
		gap: 40px;
	}
	.winner-screen p {
		font-size: 28px;
		color: white;
		font-family: Geneva, Tahoma, sans-serif;
		font-size: 20px;
		text-transform: uppercase;
	}
	button {
		cursor: pointer;
		border: none;
		background-color: transparent;
		color: white;
	}
</style>
